import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { all } from "@awesome.me/kit-73486a6a2f/icons";

// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// Font Awesome: Duotone Regular icons only
library.add(...all);
dom.i2svg(); // Convert existing icons
dom.watch(); // Watch for future icon additions

